module.exports = __webpack_public_path__ + "static/fonts/Fact-LightItalic.01fcf6f.woff";